import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import HYNewsSider from './hyNewsSider';
import HYNews from './hyNews';

class HistoryAndGame extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { hgNewsSiderData, hgNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <HYNewsSider content={hgNewsSiderData} />
                <HYNews content={hgNewsData} />
            </div>
        );
    }
}

export default errorBoundary(HistoryAndGame);
